import React from "react"

const RadioRating = (props) => {
  const {
    min,
    max,
    groupName = "",
    minScaleText,
    maxScaleText,
    onChangeHandler,
    currentAnswerValue,
  } = props

  const radioButtons = []

  for (let i = min; i <= max; i++) {
    const labelFor = `${groupName}-option-${i}`
    radioButtons.push(
      <div key={i} className="radio-option">
        <input
          data-cy={labelFor}
          id={labelFor}
          type="radio"
          name={groupName}
          defaultChecked={currentAnswerValue == i}
          value={i}
          onClick={(e) => {
            const answer = e.target.value
            onChangeHandler(answer)
          }}
        />
        <label htmlFor={labelFor}>{i}</label>
        {i === min ? <div className="helper-text">{minScaleText}</div> : null}
        {i === max ? <div className="helper-text">{maxScaleText}</div> : null}
      </div>
    )
  }

  return radioButtons
}

export default RadioRating
